// src/components/CallIcon.js
import React from 'react';
import { FaPhoneAlt } from 'react-icons/fa';

const CallIcon = () => {
  return (
    <a
      href="tel:+27693395619"
      className="fixed bottom-4 right-4 bg-perspective-green p-4 rounded-full shadow-lg text-white z-50"
      style={{ zIndex: 9999 }} // Ensures it stays on top
    >
      <FaPhoneAlt size={30} />
    </a>
  );
};

export default CallIcon;
